import { useQuery } from '@tanstack/react-query';
import { cycleCountService } from '#client/services/cycleCount/cycleCountService';

export function useReasonCodes() {
    return useQuery({
        queryKey: ['reasonCodes'],
        queryFn: async () => {
            const response = await cycleCountService.getReasonCodes();
            // Transform the response: reasonCode → label, shopifyReasonCode → value
            return response.data?.reasonCodes.map((code) => ({
                label: code.reasonCode,
                value: code.shopifyReasonCode,
                id: code.id,
            }));
        },
        staleTime: 1000 * 60 * 60, // Cache for 1 hour
        retry: 2,
    });
}
